import script from "./NewClass.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewClass.vue?vue&type=script&setup=true&lang=ts"

import "./NewClass.vue?vue&type=style&index=0&id=9d870892&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d870892"]])

export default __exports__